const config = require('./config.yaml');
const CMenu = require('../../index.js');

class CMenu_verticalAccordeon extends CMenu {
	constructor() {
		super();
		this.config = config;
		// Тип меню для определения класса
		this.menuType = 'left';
		// Имя варианта для создания глобальных событий
		this.eventNameVariantPart = 'VerticalAccordeon';
	}

	initScrollbars() {
		this.$mainMenuPanel = $('#main-menu--panel');
		this.mainMenuInstance = this.$mainMenuPanel.overlayScrollbars({
			className: 'os-theme-sberbank-main-menu',
			overflowBehavior: {
				x: 'hidden',
				y: 'scroll'
			},
		}).overlayScrollbars();
	}

	/**
	 * Инициализация логики работы компонента
	 */
	initMenu() {
		this.$navigationPanel = $('#navigation-panel');

		this.$mainMenuTrigger = $('#main-menu--trigger');
		this.$mainMenuWrapper = $('#main-menu--wrapper');
		this.$mainMenuPanelWrapper = $('#main-menu--panel-wrapper');
		this.$mainMenuPanel = $('#main-menu--panel');

		this.scrollTop = 0;
		this.$page = $('.js-page');

		if (!this.$mainMenuPanel.length) {
			return false;
		}

		this.initMainMenuLogic();
	}

	initMainMenuLogic() {
		if (this.$mainMenuTrigger.length) {
			this.$mainMenuTrigger.on('click', $.proxy(this, 'onMainMenuTriggerToggle'));
		}
	}

	onMainMenuTriggerToggle(e) {
		if (this.$mainMenuTrigger.hasClass('is-expand')) {
			$(document).on('click touchstart', $.proxy(this, 'onMenuDocumentListener'));
			this.closeMainMenu();
		} else {
			$(document).on('click touchstart', $.proxy(this, 'onMenuDocumentListener'));
			this.openMainMenu();
		}
	}

	openMainMenu() {
		this.lock();
		this.$navigationPanel.addClass('is-expand--menu');
		this.$navigationPanel.addClass('is-expand');
		this.$navigationPanel.parent().addClass('is-expand');

		this.$mainMenuPanelWrapper.velocity('stop');
		this.$mainMenuPanelWrapper
			.velocity('transition.slideLeftIn', {
				duration: 300,
				begin: (element) => {

				},
				complete: (element) => {

				}
			});

		this.$mainMenuTrigger.addClass('is-expand');
	}

	closeMainMenu() {
		this.unlock();
		this.$navigationPanel.removeClass('is-expand--menu');
		this.$navigationPanel.removeClass('is-expand');
		this.$mainMenuTrigger.removeClass('is-expand');

		this.$mainMenuPanelWrapper.velocity('stop');
		this.$mainMenuPanelWrapper
			.velocity('transition.slideLeftOut', {
				duration: 300,
				begin: (element) => {

				},
				complete: (element) => {
					this.$navigationPanel.parent().removeClass('is-expand');
				}
			});
	}

	onMenuDocumentListener(event) {
		// Если текущий элемент вне меню
		if (!$(event.target).closest(this.$mainMenuWrapper).length && !$('#popup-locker').length && this.$navigationPanel.hasClass('is-expand--menu')) {
			this.closeMainMenu();
		}
	}

	/**
	 * Блокировка
	 */
	lock() {
		this.scrollTop = $(document).scrollTop();
		$('body').addClass('is-locked');

		this.$page.css({
			position: 'fixed',
			overflow: 'hidden'
			// 'top': `-${$(document).scrollTop()}px`,
			// 'height': 'auto'
		});
	}

	/**
	 * Разблокировка
	 */
	unlock() {
		$('body').removeClass('is-locked');
		this.$page.css({
			position: 'relative',
			overflow: 'inherit'
			// 'top': `auto`,
			// 'height': '100%'
		});
		$(document).scrollTop(this.scrollTop);
	}

	/**
	 * Инициализация
	 */
	init() {
		// Меню
		this.$menu = $('.js-left-nav--vertical-accordeon');

		// Если меню на странице существует и необходимо раскрывать и закрывать
		// по клику на управляющий элемент
		if (this.$menu.length && (this.config.expandable || this.config.closable)) {
			// Все элементы ссылок в меню
			this.$links = this.$menu.find('.js-left-link');
			// Управляющий элемент
			this.$linkController = this.$menu.find('.js-icon-left-nav');
			// Класс списков (выпадашек)
			this.listClass = '.js-left-list';

			// По клику / тапу на управляющий элемент инициализировать раскрытие
			this.$linkController.on('click touchstart', $.proxy(this, 'toggle'));

			// Если необходимо закрывать списки по клику на документ и есть раскрытие списки
			if (this.config.documentClickClose && this.$links.hasClass('is-expand')) {
				// Провесить слушателя клика по документу
				$(document).on('click touchstart', $.proxy(this, 'onDocumentListener'));
				this.documentClickListen = true;
			}

			// Если меню необходимо делать фиксируемым
			if (this.config.fixedMenu) {
				// Инициализировать наблюдателя состояния фиксирующегося меню
				this.initFixMenuWatcher();
			}

		}
	}

	/**
	 * Переключение состояния списков
	 * @param  {Object} event Событие
	 */
	toggle(event) {
		const $this = $(event.currentTarget);
		// Элемент ссылки (пункт), в котором находится управляющий элемент
		const $thisLink = $this.siblings('.js-left-link');

		// Если списки закрываемы и список у текущего пункта не раскрыт
		if (this.config.closable && $thisLink.hasClass('is-expand')) {
			event.preventDefault();

			if (this.config.hideInnerOnClose) {
				// Раскрытые списки внутри текущего
				const $expandedElements = $this
					.siblings('.js-left-item')
					.find(`.js-${this.menuType}-link.is-expand`);
				// Закрыть списки
				this.close($expandedElements, true);
			}

			// Закрыть список
			this.close($thisLink);
		} else if (this.config.expandable && !$thisLink.hasClass('is-expand')) {
			event.preventDefault();

			// Если необходимо закрывать список на текщуем уровне при открытии другого
			if (this.config.hidePreviousListOnExpand) {
				// Раскрытые списки на текущем уровне
				const $expandedElements = $this
					.closest('.js-left-item')
					.siblings('.js-left-item')
					.find(`.js-${this.menuType}-link.is-expand`);
				// Закрыть списки
				this.close($expandedElements, true);
			}

			// Открыть список
			this.open($thisLink, event);
		}
	}

	/**
	 * Открытие списка
	 * @param  {Object}  $element Элемент список
	 */
	open($element) {
		// Эффект и продолжительность анимации
		const {openEffect, openDuration} = this.getOpenAnimation();

		// Если необходимо закрывать списки по клику на документ и клик по документу не слушается
		if (this.config.documentClickClose && !this.documentClickListen) {
			// Провесить слушателя клика по документу
			$(document).on('click touchstart', $.proxy(this, 'onDocumentListener'));
			this.documentClickListen = true;
		}

		$element.parents('.js-left-item').addClass('is-expand');

		$element
			.addClass('is-expand')
			.closest('.js-left-item')
			.children(this.listClass)
			.velocity(openEffect, {
				duration: openDuration,
				// Стригерить глобальное событие начала раскрытия списка
				begin: (element) => AR.events.emit(`onMenu${this.eventNameVariantPart}OpenStart`, $(element)),
				// Стригерить глобальное событие завершения раскрытия списка
				complete: (element) => AR.events.emit(`onMenu${this.eventNameVariantPart}OpenEnd`, $(element))
			});
	}

	/**
	 * Закрытие списка
	 * @param  {Object}  $element      Элемент список
	 * @param  {Boolean} closeForNext  Делается ли закрытие списка перед открытием следующего
	 */
	close($element, closeForNext) {
		// Эффект и продолжительность анимации
		const {closeEffect, closeDuration} = this.getCloseAnimation();

		$element.parents('.js-left-item').removeClass('is-expand');

		$element
			.removeClass('is-expand')
			.closest('.js-left-item')
			.children(this.listClass)
			.velocity(closeEffect, {
				duration: closeDuration,
				// Стригерить глобальное событие начала закрытия списка
				begin: (element) => AR.events.emit(`onMenu${this.eventNameVariantPart}CloseStart`, $(element)),
				// Стригерить глобальное событие завершения закрытия списка
				complete: (element) => AR.events.emit(`onMenu${this.eventNameVariantPart}CloseEnd`, $(element))
			});

		// Если необходимо закрывать списки по клику на документ
		// и слушатель клика по документу провешен
		// и у всех пунктов списки не раскрыты
		// и закрытие делается не перед открытием следующего
		if (this.config.documentClickClose && this.documentClickListen
			&& !this.$links.hasClass('is-expand') && !closeForNext) {
				// Снять слушателя клика по документу
			$(document).off('click touchstart', $.proxy(this, 'onDocumentListener'));
			this.documentClickListen = false;
		}
	}

	/**
	 * Получение эффекта и продолжительности анимации раскрытия
	 * @param  {Object} $element Элемент пункт
	 * @return {Object}          Эффект и время анимации
	 */
	getOpenAnimation() {
		return {
			openEffect: this.config.animation.open.transition,
			openDuration: this.config.animation.open.duration
		};
	}

	/**
	 * Получение эффекта и продолжительности анимации закрытия
	 * @param  {Object}  $element     Элемент пункт
	 * @return {Object}               Эффект и время анимации
	 */
	getCloseAnimation() {
		return {
			closeEffect: this.config.animation.close.transition,
			closeDuration: this.config.animation.close.duration
		};
	}

	/**
	 * Обработчик события клика / тапа / наведения курсора на документ
	 * Создаем свой обработчик вместо унаследованного,
	 * иначае при нахождении на странице нескольких вариантов, которые также унаследовали метод
	 * и для одного из них сделать $.off(), то для всех остальных также отключаюется, т.е наследуют
	 * @param  {Object} event Событие
	 */
	onDocumentListener(event) {
		// Обращаемся к родительскому методу
		super.onDocumentListener(event);
	}
}

const cMenu_verticalAccordeon = new CMenu_verticalAccordeon();

cMenu_verticalAccordeon.init();
cMenu_verticalAccordeon.initMenu();
cMenu_verticalAccordeon.initScrollbars();

AR.pushComponent(cMenu_verticalAccordeon, 'cMenu_verticalAccordeon');



// WEBPACK FOOTER //
// ./temp/components/menu/.variant/vertical-accordeon/index.js